export const HTML_ELEMENT = {
    div: '<div>',
    lineBreak: '</br>'
};
